"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendRecurringPayment = void 0;
var qs_1 = require("qs");
exports.backendRecurringPayment = function (axios) { return ({
    getRecurringPayments: function (request) {
        var query = qs_1.stringify(request.params, { arrayFormat: 'comma' });
        return axios.get("/recurring-payments?" + query);
    },
    getRecurringPayment: function (_a) {
        var recurringPaymentNo = _a.pathParams.recurringPaymentNo, restRequest = __rest(_a, ["pathParams"]);
        return axios.get("/recurring-payments/" + recurringPaymentNo, restRequest);
    },
    getRecurringPaymentsChangeHistory: function (_a) {
        var params = _a.params;
        var query = qs_1.stringify(params, { arrayFormat: 'comma' });
        return axios.get("/recurring-payments/" + params.recurringPaymentNo + "/history/info?" + query);
    },
    getRecurringPaymentsStatusHistory: function (_a) {
        var recurringPaymentNo = _a.pathParams.recurringPaymentNo, restRequest = __rest(_a, ["pathParams"]);
        return axios.get("/recurring-payments/" + recurringPaymentNo + "/history/status", restRequest);
    },
    putRecurringPaymentsStatus: function (_a) {
        var data = _a.data;
        return axios.put('/recurring-payments/change-status', data);
    },
    putRecurringPayments: function (_a) {
        var recurringPaymentNo = _a.pathParams.recurringPaymentNo, data = _a.data;
        return axios.put("/recurring-payments/" + recurringPaymentNo + "/product", data);
    },
    putRecurringPaymentsClose: function (request) {
        return axios.put('/recurring-payments/close', request.data);
    }
}); };
